import { useContext, useEffect, useState } from "react";
import { OperationContext } from "../CreateOperation";
import style from "./style.module.scss";
import { useSearchParams } from "react-router";
import { OperationConstant } from "../../../core/_constant";
import { Empty, Radio } from "antd";
import { LandingPointingForm } from "./landing/LandingPointingForm";
import { BoardingPointingForm } from "./boarding/BoardingPointingForm";
import { TitleBadge } from "../components/TitleBadge";
import { Assets } from "../../../../../assets";
import CustomModal from "../../../../../common/components/Modal/CustomModal";
import { CustomButton } from "../../../../../common/components/CustomButton/CustomButton";
import { downloadPDF } from "../../../../../utilities/downloadPdf";
import { usePointingContainerStore, usePointingBoardingContainerStore } from "../../../store/PointingStore";


export const PointingForm = () => {
  const { initialValue } = useContext(OperationContext);

  const [searchParams, setSearchParams] = useSearchParams();

  const { pageState: landingPageState } = usePointingContainerStore();
  const { pageState: boardingPageState } = usePointingBoardingContainerStore();

  const typeFromURL = parseInt(searchParams.get("movment") || "");
  const [isContainer, setIsContainer] = useState(false);
  const type = (searchParams.get("type") || "").toString();
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [isLoadingFr, setIsLoadingFr] = useState(false);
  const [isLoadingEn, setIsLoadingEn] = useState(false);


  const POINTING_ALL_TYPE = [
    initialValue?.debarkationMovement?.id && {
      label: OperationConstant.LANDING_LABEL,
      value: initialValue?.debarkationMovement?.id,
      component: <LandingPointingForm />,
    },
    initialValue?.embarkationMovement?.id && {
      label: OperationConstant.BOARDING_LABEL,
      value: initialValue?.embarkationMovement?.id,
      component: <BoardingPointingForm />,
    },
  ]?.filter((item) => item);

  const currentMovement = POINTING_ALL_TYPE.find(item => item.value === typeFromURL);
  const activePageState = currentMovement?.label === OperationConstant.LANDING_LABEL 
    ? landingPageState 
    : boardingPageState;

    const buildPdfUrl = (locale: "fr" | "en") => {
      const params = new URLSearchParams();
    
      params.append("movement.id", typeFromURL.toString());
      params.append("isLoadControlled", "true");
      params.append("locale", locale);
    
      if (activePageState?.page) {
        params.append("page", String(activePageState.page));
      }
    
      if (activePageState?.itemsPerPage) {
        params.append("itemsPerPage", String(activePageState.itemsPerPage));
      }
    
      if (activePageState?.order) {
        Object.entries(activePageState.order).forEach(([key, value]) => {
          if (value) {
            params.append(`order[${key}]`, String(value));
          }
        });
      }
    
      return `/api/container_loads/controlled/pdf?${params.toString()}`;
    };

  const onOpenModal = () => {
    setIsOpenModal(true);
  }

  const OnDownloadFr = async () => {
      setIsLoadingFr(true);
      try {
        await downloadPDF(
          buildPdfUrl("fr"),
          `EIR_${initialValue?.travelReference}_FR.pdf`
        );
      } finally {
        setIsLoadingFr(false);
        setIsOpenModal(false);
      }
    };

const OnDownloadEn = async () => {
    setIsLoadingEn(true);
    try {
      await downloadPDF(
        buildPdfUrl("en"),
        `EIR_${initialValue?.travelReference}_EN.pdf`
      );
    } finally {
      setIsLoadingEn(false);
      setIsOpenModal(false);
    }
};

  const getStatusesByMovementId = (movementId: number) => {
    if (initialValue?.debarkationMovement?.id === movementId) {
      return initialValue?.debarkationMovement?.loadPossessionStatus ?? [];
    }

    if (initialValue?.embarkationMovement?.id === movementId) {
      return initialValue?.embarkationMovement?.loadPossessionStatus ?? [];
    }

    return [];
  };

  useEffect(() => {
    if (type === "container" || ((type === null || type === undefined || type === "") && (initialValue?.debarkationMovement?.loadPossessionStatus[0].id === "CONTAINER" || initialValue?.embarkationMovement?.loadPossessionStatus[0].id === "CONTAINER"))) {
      setIsContainer(true);
    } else {
      setIsContainer(false);
    }
  }, [typeFromURL, type]);

  useEffect(() => {
    if (!initialValue) return;
    if (!POINTING_ALL_TYPE.length) return;
  
    const currentMovement = searchParams.get("movment");
    const currentType = searchParams.get("type");
  
    let movementId = currentMovement ? Number(currentMovement) : null;
  
    const movementExists = POINTING_ALL_TYPE.some(
      (item: any) => item.value === movementId
    );
  
    if (!movementId || !movementExists) {
      movementId = POINTING_ALL_TYPE[0]?.value;
    }
  
    if (!movementId) return;
  
    const statuses = getStatusesByMovementId(movementId);
    const firstType = statuses?.[0]?.id;
  
    const typeExists = currentType
      ? statuses.some(
          (item: any) => item.id?.toLowerCase() === currentType.toLowerCase()
        )
      : false;
  
    const newParams = new URLSearchParams(searchParams);
    let shouldUpdate = false;
  
    if (currentMovement !== movementId.toString()) {
      newParams.set("movment", movementId.toString());
      shouldUpdate = true;
    }
  
    if (!currentType || !typeExists) {
      if (firstType) {
        newParams.set("type", firstType.toLowerCase());
      } else {
        newParams.delete("type");
      }
  
      shouldUpdate = true;
    }
  
    if (shouldUpdate) {
      setSearchParams(newParams, { replace: true });
    }
  }, [initialValue, searchParams]);

  /* const handleChangeManifestoType = (value: number) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set("movment", value?.toString());
    let reachedType = false;
    const keysToDelete: string[] = [];

    newParams.forEach((_, key) => {
      if (reachedType) {
        keysToDelete.push(key);
      }
      if (key === "movment") {
        reachedType = true;
      }
    });

    keysToDelete.forEach((key) => newParams.delete(key));

    setSearchParams(newParams);
  }; */
  
  const handleChangeManifestoType = (value: number) => {
    const newParams = new URLSearchParams(searchParams);
  
    const statuses =
      initialValue?.debarkationMovement?.id === value
        ? initialValue?.debarkationMovement?.loadPossessionStatus ?? []
        : initialValue?.embarkationMovement?.id === value
          ? initialValue?.embarkationMovement?.loadPossessionStatus ?? []
          : [];
  
    const firstType = statuses?.[0]?.id;
  
    newParams.set("movment", value.toString());
  
    if (firstType) {
      newParams.set("type", firstType.toLowerCase());
    } else {
      newParams.delete("type");
    }
  
    setSearchParams(newParams);
  };

  const activeComponent =
    POINTING_ALL_TYPE.find((item) => item?.value === typeFromURL)?.component ||
    POINTING_ALL_TYPE[0]?.component;

  return (
    <>
    {
      typeFromURL ? (
        <div className={style.pointing}>
      <div className="d-flex gap-2 mb-4">
        <TitleBadge
          label="Référence du voyage"
          value={initialValue?.travelReference}
        />
        <TitleBadge
          label="Opération"
          value={initialValue?.operationType?.label}
        />
      </div>
      <div className="d-flex row-gap-4 mb-4 align-items-center justify-content-between">
        <Radio.Group
          onChange={(e) => handleChangeManifestoType(e.target.value)}
          value={typeFromURL}
          optionType="button"
          buttonStyle="solid"
        >
          {POINTING_ALL_TYPE?.map((item: any) => (
            <Radio value={item?.value}>{item?.label}</Radio>
          ))}
        </Radio.Group>
        { isContainer && (
          <img
            alt="export_pdf"
            className="icon-export__image"
            src={Assets.icons.png.pdf}
            onClick={() => {
              onOpenModal()
            }}
            />
        )}
        
      </div>
      <div className="">{activeComponent}</div>
    </div>
      ) : (
        <Empty description="En attente de manifeste"/>
      )
    }
    <CustomModal
          title="Choisir la langue souhaitée."
          isOpen={isOpenModal} 
          hanldeCloseModal={() => {setIsOpenModal(false)}}
          width={400}
          centered
          >
<div className="mt-3 d-flex flex-column align-items-stretch gap-3">
  <CustomButton
    type="button"
    variant="secondary"
    className="w-100"
    onClick={() => OnDownloadFr()}
    isLoading={isLoadingFr}
  >
    Français
  </CustomButton>
  <CustomButton
    type="button"
    variant="secondary"
    className="w-100"
    onClick={() => OnDownloadEn()}
    isLoading={isLoadingEn}
  >
    Anglais
  </CustomButton>
</div>
                   </CustomModal>
   </> 
  );
};
